'use client';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import { PopTopicTab } from '@fe-news/constants/pop-topic/type';
import PopTopicInfiniteListSkeleton from '@fe-news/components/molecules/PopTopicInfiniteList/PopTopicInfiniteListSkeleton';

const DynamicPopTopicList = dynamic(() => import('./index'), {
  loading: () => <PopTopicInfiniteListSkeleton />,
  ssr: false
});

type DynamicPopTopicListProps = {
  tab: PopTopicTab;
  onClickTab: (tab: PopTopicTab) => void;
};

const DynamicLoadPopTopicList: React.FC<DynamicPopTopicListProps> = props => {
  return (
    <Suspense fallback={<PopTopicInfiniteListSkeleton />}>
      <DynamicPopTopicList {...props} />
    </Suspense>
  );
};

export default DynamicLoadPopTopicList;
